import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {ErrorService} from '~/app/core/services/error.service';
import {BehaviorSubject, Observable, lastValueFrom} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Chain} from '@model/Chain';
import {Division} from '@model/Division';
import {ItemSetup} from '@model/ItemSetup';
import {ItemSetupDetails} from '@model/ItemSetupDetails';
import {BaseService} from "~/app/core/services/base.service";

const GET_CHAIN_LIST = '/itemsp/chnlist/'; // GET {hoId}
const GET_DIVISION_LIST = '/itemsp/dclist/'; // GET {hoId}
const GET_ITEM_LIST = '/itemsp/itemlist/'; // GET {hoId}/{chain}/{dc}/
const GET_ITEM_DETAIL = '/itemsp/itemdetail/'; // GET {hoId}/{itemNum}/{chain}/{divId}
const ADD_ITEM = '/itemsp/additem/'; // POST
const DELETE_ITEM = '/itemsp/delete/'; // DELETE
const UPDATE_ITEM = '/itemsp/updateitem'; // PUT


@Injectable({
  providedIn: 'root'
})
export class ItemSetupService extends BehaviorSubject<any[]> {

  public hoId: string = '';
  public userId: string = '';
  private data: any[] = [];
  private chain: string = '';
  private division: string = '';

  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService) {
    super([]);
  }

  public read(hoId: string, chain: string, store: string, user: string) {
    if (this.data.length) {
      return super.next(this.data);
    }

    this.fetch(GET_ITEM_LIST, hoId, chain, store, user)
      .pipe(
        tap(data => {
          console.log(data);
          this.data = data;
        })
      )
      .subscribe(data => {
        super.next(data);
      });

  }

  async getChainList(hoId: string) {
    this.hoId = hoId;
    console.warn(this.configuration.RESTURL + GET_CHAIN_LIST + hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getChainList',
      'item-setup-service',
      this.configuration.RESTURL + GET_CHAIN_LIST + hoId))
      .catch(this.errorService.handleError('item-setup.service getChainList(' + hoId + ')', []));
    return results as Chain[];
  }

  async getDivisionList(hoId: string) {
    this.hoId = hoId;
    console.warn(this.configuration.RESTURL + GET_DIVISION_LIST + hoId);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getDivisionList',
      'item-setup-service',
      this.configuration.RESTURL + GET_DIVISION_LIST + hoId))
      .catch(this.errorService.handleError('item-setup.service getDivisionList(' + hoId + ')', []));
    return results as Division[];
  }

  async getItemList(hoId: string, chain: string, division: string) {
    this.hoId = hoId;
    this.chain = chain;
    this.division = division;
    console.warn(this.configuration.RESTURL + GET_ITEM_LIST + hoId + '/' + chain + '/' + division);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getItemList',
      'item-setup-service',
      this.configuration.RESTURL + GET_ITEM_LIST + hoId + '/' + chain + '/' + division))
      .catch(this.errorService.handleError('item-setup.service getStoreApGlXrefList(' + hoId + ', ' + chain + ', ' + division + ')', []));
    return results as ItemSetup[];
  }


  async getItemDetails(chain: string, division: string, hoId: string, itemNum: string) {
    console.warn(this.configuration.RESTURL + GET_ITEM_DETAIL + hoId + '/' + itemNum + '/' + chain + '/' + division);
    const results = await lastValueFrom(this.baseService.getHttp(
      'getItemDetails',
      'item-setup-service',
      this.configuration.RESTURL + GET_ITEM_DETAIL + hoId + '/' + itemNum + '/' + chain + '/' + division))
      .catch(this.errorService.handleError('item-setup.service getItemDetails(' + hoId + ', ' + itemNum + ', ' + chain + ', ' + division + ')', []));
    return results as ItemSetupDetails;
  }


  delete(data: any): Observable<any> {
    const deletObj = {
      'hoId': +this.hoId,
      'chain': '' + this.chain,
      'dc': '' + this.division,
      'itemNum': data.itemNum,
    };

    this.reset();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: deletObj

    };
    return this.baseService.deleteHttpObject<any>(
      'delete',
      'item-setup-service',
      this.configuration.RESTURL + DELETE_ITEM, options)
      .pipe(
        catchError(this.errorService.handleError('item-setup.service delete(' + deletObj + ')', []))
      );
  }

  public save(data: any): Observable<any> {
    const updateObj = {
      'hoId': +this.hoId,
      'chain': '' + this.chain,
      'dc': '' + this.division,
      'itemNum': data.itemNum,
      'exRef': +data.xref,
      'glCode': data.catCd
    };
    this.reset();
    console.warn(this.configuration.RESTURL + UPDATE_ITEM, updateObj);
    return this.baseService.putHttpObject<any>(
      'save',
      'item-setup-service',
      this.configuration.RESTURL + UPDATE_ITEM, updateObj)
      .pipe(
        catchError(this.errorService.handleError('item-setup.service  save= ' + updateObj, []))
      );
  }

  private fetch(action: string = '', hoId: string, chain: string, store: string, user: string): Observable<any[]> {
    console.warn('Fetching...  Action=' + action + ' - ' + ' hoId=' + hoId + ' chain=' + chain + ' store=' + store + ' user=' + user);
    return this.baseService
      .getHttp(
        'fetch',
        'item-setup-service',
        this.configuration.RESTURL + GET_ITEM_LIST + hoId + '/' + chain + '/' + store + '/' + user)
      .pipe(map(res => <any[]>res));
  }

  private reset() {
    this.data = [];
  }

  private serializeModels(data?: any): string {
    console.error(typeof data);
    console.log(data);
    if (data instanceof Object) {
      return `${JSON.stringify([data])}`;
    } else {
      return data;
    }
  }
}

